import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FeedbackPanelTabsComponent } from './feedback-panel-tabs.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule
	],
	declarations: [
		FeedbackPanelTabsComponent
	],
	exports: [
		FeedbackPanelTabsComponent
	]
})
export class FeedbackPanelTabsModule {}
